import MinPage from '../../../components/page.vue'
import MultiSelect from '../../../components/multiSelect.vue'
import {api, getHallCode} from "../../../common/config"
import {store} from '../../../store/store.js'
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import LoginMask from '../../../components/loginmask.vue';
import {StorageUtil} from "../../../common/Auth";


export default {
    name: 'libraryresource',
    components: {
        MinPage,
        MultiSelect,
        LoginMask
    },
    data() {
        return {
            webType: store.webType, /*0:平台1：图书馆*/
            pageNo: 1,
            area: {
                province: [{desc: '省', value: '', rules: [{name: 'required'}]}],
                city: [{desc: '市', value: '', rules: [{name: 'required'}]}],
                area: [{desc: '区', value: ''}]
            },
            alertBoxFail: false,
            alertBoxSuccess: false,
            alertBoxSuccessMsg: "",
            alertBoxFailMsg: "",
            params: "",
            idCard: "",
            reservations: {},
            mag: '',
            errorCode: 0,
            isReservationClick: false,
            totalPage: 1,
            isbn: '',
            librarys: [],
            libCode: '',
            customerScope:0,
            currHallCodeExist:0,
            activeTime:0
        }
    },
    beforeMount() {
        if(!StorageUtil.getString("activeTime")){
            this.activeTime=0 
        }else{
            this.activeTime=StorageUtil.getString("activeTime")
            StorageUtil.removeObject("activeTime")

        } 
        this.isbn = this.$route.query.isbn;
        this.libCode = this.$route.query.hallCode || this.$route.query.libCode ||'';
        this.getLibraryInfo(1);
    },
    watch:{
        userInfo: function (newValue, oldValue) {
            console.log(newValue,'用户信息')
           if(newValue){
            this.getReservations();
           }
        },
    },
    computed:{
        userInfo(){
            return  store.wrap.user
        }
    },
    methods: {
        /**获取馆藏信息**/       
        getLibraryInfo(pageNo){
       // currHallCodeExist 0 不存在本馆  1 存在本馆
       //不存在本馆，是当前客户下的范围
       //  存在本馆，不是当前客户下范围
           this.currHallCodeExist=StorageUtil.getString("currHallCodeExist");      
            if(this.currHallCodeExist==0){
            this.customerScope=1
            }else{
                this.customerScope=0
            }
            this.pageNo = pageNo;
            let url = api.book.stayLibrarys.replace('{pageNo}', pageNo).replace('{pageCount}', 10)
                .replace('{isbn}', this.isbn).replace('{customerScope}', this.customerScope) +this.params+ "&libCode=" + this.libCode + "&nonceStr=" + (new Date());
            ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
                let dataStr = data.resultList;
                if (dataStr == null) {
                    dataStr = {};
                }
                dataStr.map(function (item, index) {
                    item.statusBtn = 0;
                    if (item.status === 1) {
                        item.status = "在馆";
                    } else if (item.status === 2) {
                        item.status = "在借";
                    } else if (item.status === 5) {
                        item.status = "在馆 ";
                    }
                    if (item.deposit === 0) {
                        item.deposit = "无押金";
                    } else if (item.deposit === 1) {
                        item.deposit = "有押金";
                    }
                    return item
                });
                this.librarys = dataStr;
                this.totalPage = data.totalPage;
                this.getReservations();
            }, null, this);
        },
        /**查看平台图书馆的某本图书是否已预约**/
        checkAppoint(libBookId,belongLibraryCode){
            let that = this;
            return new Promise((resolve,reject)=>{
                let url =api.reservation.getAppointStaus.replace('{readerId}',store.user.readerId).replace('{libCode}',belongLibraryCode).replace('{isbn}',that.isbn);
                ajaxUtil.ajaxJson(url,'','GET',(result)=>{
                    resolve(result)
                },(error)=>{
                    reject(error)
                }, that)
            })
        },

        /**
         * 平台预约
         */
        reservation(libBookId,belongLibraryCode) {
            let idCard = store.func.getUserIdCard();
            if (idCard !== "") {
                this.idCard = idCard;
            } else {
                store.index.$refs.login.showLogin()
                return;
            }
            if (this.isReservationClick) {
                return;
            }
            if(belongLibraryCode){                
                let url =api.reservation.getAppointStaus.replace('{readerId}',store.user.readerId).replace('{libCode}',belongLibraryCode).replace('{isbn}',this.isbn);
                ajaxUtil.ajaxJson(url,'','GET',(result)=>{
                    if(result.appointStatus){
                        this.appointSet(libBookId)
                    }else{
                        this.alertBoxFailMsg = "不可重复预约!";
                        this.alertBoxFail = true;
                    }
                }, null,this)

            }else{
                this.appointSet(libBookId)
            }
        },
        /**预约**/
        appointSet(libBookId){
            this.isReservationClick = true;
            let appointRequestDto = {};
            appointRequestDto.appointType = 1;
            appointRequestDto.id = libBookId;
            appointRequestDto.idCard = this.idCard;
            ajaxUtil.ajaxJson(api.reservation.appoint, appointRequestDto, "post",  (data)=> {
                if (data.needIdCard == 0) {
                    this.alertBoxSuccessMsg = "预约成功!";
                } else if (data.needIdCard === 1) {
                    this.mag = "携带身份证";
                    this.alertBoxSuccessMsg = "预约成功!";
                }
                this.alertBoxSuccess = true;
                this.getLibraryInfo(this.pageNo);
                this.isReservationClick = false;
            },  (data) =>{
                this.errorCode = data.errorCode;
                if (data.errorCode == 30202) {
                    this.alertBoxFailMsg = "您在该图书馆无预约权限！";
                } else if (data.errorCode == 30303) {
                    this.alertBoxFailMsg = "";
                } else {
                    this.alertBoxFailMsg = "本书不支持外借!";
                }
                this.alertBoxFail = true;
                this.isReservationClick = false;
            }, this);
        },
        /**
         * 设置是否可预约
         * */
        setReservations() {
            let librarys = this.librarys;
            let reservations = this.reservations;
            for (let i = 0; i < librarys.length; i++) {
                //在馆，有预约权限，并且在没在预约列表中
                if ((librarys[i].status == '在馆' || librarys[i].status == '在馆 ') && librarys[i].canAppoint == 1) {
                    if (librarys[i].storeRoom == "基藏库") {
                        librarys[i].statusBtn = 0;
                        return;
                    }
                    librarys[i].statusBtn = 1;
                    let libBookId = librarys[i].libBookId;
                    for (let j = 0, len = reservations.length; j < len; j++) {
                        if (libBookId === reservations[j].id) {//0:无按钮，1:有按钮，2:自己已经预约
                            librarys[i].statusBtn = 2;
                        }
                    }
                    if (librarys[i].statusBtn === 1 && librarys[i].status === '在馆 ') {
                        librarys[i].statusBtn = 0;
                    }
                } else {
                    librarys[i].statusBtn = 0;
                }
            }
        },
        /**
         * 获取已预约列表
         * */
        // 登录成功之后获取已预约列表
        getReservations() { 
            if (!StorageUtil.getObject('user')) {
                // 设置是否可预约
                this.setReservations(); 
                return;
            }
            let url = api.reservation.list.replace('{pageNo}', 1).replace('{pageCount}', 20).replace('{idCard}', store.func.getUserIdCard()) + "&nonceStr=" + (new Date());
            console.log("library")
            ajaxUtil.ajaxJson(url, '', 'get', (data) => {
                this.reservations = data.resultList;
                this.setReservations();
            }, null, this)
        },
        search(searchCondition) {
            let params = CommonUtil.getAllProperty(searchCondition);
            this.params = params;
            this.getLibraryInfo(1);
        },
        //关闭弹窗
        closeAlertBox() {
            this.alertBoxFail = false;
            this.alertBoxSuccess = false;
        },
        /**
         * 跳转到图书馆页面
         * @param hallCode
         */
        toLibrary: function (hallCode, libCodeId, level, stayLibraryName) {
            this.$router.push({
                path: '/introduce',
                query: {
                    libId: libCodeId,
                    fromSearch: 0,
                    libCode: hallCode,
                    libName: stayLibraryName,
                    libLevel: level,
                    latLng: store.localtionArea.latLng
                }
            });
        },

        //查看预约
        checkAppointment(){
            this.$router.push({path: '/apply', query: {hallCode: this.libraryName}});
        },
        //翻页操作
        pageChange(pageNo) {
            CommonUtil.mergeQuery(this, {page: pageNo});
            this.pageNo = pageNo;
            this.getLibraryInfo(this.pageNo);
        },
    }
}
